export default __webpack_public_path__ + "static/media/mock.d3f9afce.png";